import { useEffect, useState } from "react";
import AdminHeader from "../../component/AdminHeader";
import Icons from "../../myIcon/Icons";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";

const dashboardListEndpoint = ApiEndpoints.Dashboard.List;
const MonthlyEndpoint = ApiEndpoints.Dashboard.monthlycount;

export default function Dashboard() {
    const [leadsCount, setLeadsCount] = useState();
    const [tempCount, setTempCount] = useState();
    const [selectedMonth, setSelectedMonth] = useState({
        apply_now_count: "",
        blog_count: "",
        branch_count: "",
        career_count:"",
        contact_form_count:"",
        media_count:"",
        schedule_visit_count:"",
        seo_count:"",
        seo_count:"",
        dynamicPage_count:"",
    });

    const getLeadsCount = async () => {
        try {
            const response = await ApiRequest("GET", dashboardListEndpoint);
            setLeadsCount(response);
            setTempCount(response);
        } catch (error) {
            console.error("Error fetching leads count:", error);
        }
    }

    useEffect(() => {
        getLeadsCount();
    }, []);


    // monthly 
    const handleChange = async (e) => {
        const { name, value } = e.target;

        if (value !== "") {
            setSelectedMonth((prev) => ({
                ...prev,
                [name]: value,
            }));
            try {
                const response = await ApiRequest("GET", `${MonthlyEndpoint}/${value}`);
                setLeadsCount((prev) => ({
                    ...prev,
                    [name]: response[name],
                }));
            } catch (error) {
                console.error("Error fetching leads count:", error);
            }
        } else {
            setLeadsCount((prev) => ({
                ...prev,
                [name]: tempCount[name],
            }));
            setSelectedMonth((pre) => ({
            ...pre,
            [name]: "",
        }))
        }
    };

    const handleRefresh = async (name) => {
        setLeadsCount((prev) => ({
            ...prev,
            [name]: tempCount[name],
        }));

        setSelectedMonth((pre) => ({
            ...pre,
            [name]: "",
        }))
    };

    const year = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    const options = [
        { value: year + "-01", title: "January" },
        { value: year + "-02", title: "February" },
        { value: year + "-03", title: "March" },
        { value: year + "-04", title: "April" },
        { value: year + "-05", title: "May" },
        { value: year + "-06", title: "June" },
        { value: year + "-07", title: "July" },
        { value: year + "-08", title: "August" },
        { value: year + "-09", title: "September" },
        { value: year + "-10", title: "October" },
        { value: year + "-11", title: "November" },
        { value: year + "-12", title: "December" }
    ];

    const dropData = options.filter((item) => {
        const month = item.value.split("-").map(Number)[1];
        return month <= currentMonth;
    });


    const pagename = {
      name: 'Dashboard',
      user: 'Admin',
      innerpage: 'Dashboard'
    }

  return (
    <>
    <AdminHeader pagename={pagename}/>
 
    <div className="add-btn-section">
        <div className="row">
            <div class="col-lg-4">
                <div class="home-dashbox grey-card">
                    <div class="dashbox-month">
                        <span>Total Blogs</span>
                        <div>
                            <select value={selectedMonth.blog_count} onChange={handleChange} name="blog_count" >
                                <option value="">All Months</option>
                                {dropData.map((drop, index) => (
                                <option key={index} value={drop.value}>{drop.title}</option>
                                ))}
                            </select>
                            <Link onClick={() => handleRefresh("blog_count")}><Icons name="rotateRight" /></Link>
                        </div>
                    </div>
                    <h4>{leadsCount?.blog_count}</h4>
                    <div class="dashbox-link">
                        <p>Blogs</p>
                        <Link to="blog">See Full List</Link>
                    </div>
                    <img src="/assets/wave.webp" class="dash-wave" alt="wave" />
                </div>
            </div>

            <div class="col-lg-4">
              <div class="home-dashbox pink-card">
                  <div class="dashbox-month">
                      <span>Total Leads</span>
                      <div>
                            <select value={selectedMonth.contact_form_count} onChange={handleChange} name="contact_form_count" >
                                <option value="">All Months</option>
                                {dropData.map((drop, index) => (
                                    <option key={index} value={drop.value}>{drop.title}</option>
                                ))}
                            </select>
                            <Link onClick={() => handleRefresh("contact_form_count")}><Icons name="rotateRight" /></Link>
                      </div>
                  </div>
                  <h4>{leadsCount?.contact_form_count}</h4>
                  <div class="dashbox-link">
                      <p>Contact Us</p>
                      <Link to="contact">See Full List</Link>
                  </div>
                  <img src="/assets/wave.webp" class="dash-wave" alt="wave"/>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="home-dashbox purple-card">
                  <div class="dashbox-month">
                      <span>Total Leads</span>
                      <div>
                            <select value={selectedMonth.schedule_visit_count} onChange={handleChange} name="schedule_visit_count" >
                                <option value="">All Months</option>
                                {dropData.map((drop, index) => (
                                    <option key={index} value={drop.value}>{drop.title}</option>
                                ))}
                            </select>
                            <Link onClick={() => handleRefresh("schedule_visit_count")}><Icons name="rotateRight" /></Link>
                      </div>
                  </div>
                  <h4>{leadsCount?.schedule_visit_count}</h4>
                  <div class="dashbox-link">
                      <p>Schedule A Visit</p>
                      <Link to="schedule-visit">See Full List</Link>
                  </div>
                  <img src="/assets/wave.webp" class="dash-wave" alt="wave"/>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="home-dashbox orange-card">
                  <div class="dashbox-month">
                      <span>Total Leads</span>
                      <div>
                            <select value={selectedMonth.apply_now_count} onChange={handleChange} name="apply_now_count" >
                                <option value="">All Months</option>
                                {dropData.map((drop, index) => (
                                    <option key={index} value={drop.value}>{drop.title}</option>
                                ))}
                            </select>
                            <Link onClick={() => handleRefresh("apply_now_count")}><Icons name="rotateRight" /></Link>
                      </div>
                  </div>
                  <h4>{leadsCount?.apply_now_count}</h4>
                  <div class="dashbox-link">
                      <p>Apply Now</p>
                      <Link to="apply-now">See Full List</Link>
                  </div>
                  <img src="/assets/wave.webp" class="dash-wave" alt="wave"/>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="home-dashbox green-card">
                  <div class="dashbox-month">
                      <span>Total Application</span>
                      <div>
                            <select value={selectedMonth.career_count} onChange={handleChange} name="career_count" >
                                <option value="">All Months</option>
                                {dropData.map((drop, index) => (
                                    <option key={index} value={drop.value}>{drop.title}</option>
                                ))}
                            </select>
                            <Link onClick={() => handleRefresh("career_count")}><Icons name="rotateRight" /></Link>
                      </div>
                  </div>
                  <h4>{leadsCount?.career_count}</h4>
                  <div class="dashbox-link">
                      <p>Career</p>
                      <Link to="career">See Full List</Link>
                  </div>
                  <img src="/assets/wave.webp" class="dash-wave" alt="wave"/>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="home-dashbox blue-card">
                  <div class="dashbox-month">
                      <span>Total SEO Count</span>
                      <div>
                            <select value={selectedMonth.seo_count} onChange={handleChange} name="seo_count">
                                <option value="">All Months</option>
                                {dropData.map((drop, index) => (
                                    <option key={index} value={drop.value}>{drop.title}</option>
                                ))}
                            </select>
                            <Link onClick={() => handleRefresh("seo_count")}><Icons name="rotateRight" /></Link>
                      </div>
                  </div>
                  <h4>{leadsCount?.seo_count}</h4>
                  <div class="dashbox-link">
                      <p>SEO</p>
                      <Link to="seo">See Full List</Link>
                  </div>
                  <img src="/assets/wave.webp" class="dash-wave" alt="wave"/>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="home-dashbox yellow-card">
                  <div class="dashbox-month">
                      <span>Total Branch</span>
                      <div>
                            <select value={selectedMonth.branch_count} onChange={handleChange} name="branch_count" >
                                <option value="">All Months</option>
                                {dropData.map((drop, index) => (
                                    <option key={index} value={drop.value}>{drop.title}</option>
                                ))}
                            </select>
                            <Link onClick={() => handleRefresh("branch_count")}><Icons name="rotateRight" /></Link>
                      </div>
                  </div>
                  <h4>{leadsCount?.branch_count}</h4>
                  <div class="dashbox-link">
                      <p>Branch</p>
                      <Link to="branch">See Full List</Link>
                  </div>
                  <img src="/assets/wave.webp" class="dash-wave" alt="wave"/>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="home-dashbox aqua-card">
                  <div class="dashbox-month">
                      <span>Total Media</span>
                      <div>
                            <select value={selectedMonth.media_count} onChange={handleChange} name="media_count" >
                                <option value="">All Months</option>
                                {dropData.map((drop, index) => (
                                    <option key={index} value={drop.value}>{drop.title}</option>
                                ))}
                            </select>
                            <Link onClick={() => handleRefresh("media_count")}><Icons name="rotateRight" /></Link>
                      </div>
                  </div>
                  <h4>{leadsCount?.media_count}</h4>
                  <div class="dashbox-link">
                      <p>News & Media</p>
                      <Link to="news">See Full List</Link>
                  </div>
                  <img src="/assets/wave.webp" class="dash-wave" alt="wave"/>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="home-dashbox darkpink-card">
                  <div class="dashbox-month">
                      <span>Total Dynamic Pages</span>
                      <div>
                            <select value={selectedMonth.dynamicPage_count} onChange={handleChange} name="dynamicPage_count" >
                                <option value="">All Months</option>
                                {dropData.map((drop, index) => (
                                    <option key={index} value={drop.value}>{drop.title}</option>
                                ))}
                            </select>
                            <Link onClick={() => handleRefresh("dynamicPage_count")}><Icons name="rotateRight" /></Link>
                      </div>
                  </div>
                  <h4>{leadsCount?.dynamicPage_count}</h4>
                  <div class="dashbox-link">
                      <p>Dynamic Page</p>
                      <Link to="dynamic-page">See Full List</Link>
                  </div>
                  <img src="/assets/wave.webp" class="dash-wave" alt="wave"/>
              </div>
            </div>

        </div>
    </div>
    </>
  )
}
